import React, {Component} from 'react';
import VariantSelector from './VariantSelector';
import {Link} from 'react-router-dom';

class Product extends Component {
  constructor(props) {
    super(props);

    let defaultOptionValues = {};
    this.props.product.options.forEach((selector) => {
      defaultOptionValues[selector.name] = selector.values[0].value;
    });
    this.state = { selectedOptions: defaultOptionValues };

    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.findImage = this.findImage.bind(this);
  }

  findImage(images, variantId) {
    const primary = images[0];

    const image = images.filter(function (image) {
      return image.variant_ids.includes(variantId);
    })[0];

    return (image || primary).src;
  }

  handleOptionChange(event) {
    const target = event.target
    let selectedOptions = this.state.selectedOptions;
    selectedOptions[target.name] = target.value;

    const selectedVariant = this.props.client.product.helpers.variantForOptions(this.props.product, selectedOptions)

    this.setState({
      selectedVariant: selectedVariant,
      selectedVariantImage: selectedVariant.attrs.image
    });
  }

  handleQuantityChange(event) {
    this.setState({
      selectedVariantQuantity: event.target.value
    });
  }

  render() {
    let variantImage = this.state.selectedVariantImage || this.props.product.images[0]
    let productUrl = '/products/' + this.props.product.handle;
    return (
      <div className="Product">
        <Link className="card-image-wrapper-link" to={productUrl}>
          <div className="card-image-wrapper">
            {this.props.product.images.length ? <img src={variantImage.src} alt={`${this.props.product.title} product shot`}/> : null}
          </div>
          <div className="card-info">
            <h5 className="Product__title">{this.props.product.title}</h5>
            {this.props.product.availableForSale ? '' : 'sold out'}
          </div>
        </Link>
      </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Product.js